import '../../assets/authcss.css';
import {useState} from 'react';
import {Link} from 'react-router';
import {authservices} from '../../services/authServices';
import { Toast } from 'primereact/toast';
import {useRef} from 'react';
const Forgotpassword = () =>{ 
const toast = useRef(null);
const [initialvalues,setValues] = useState({
	 'email':'',
	 'password':''
});
	

const onChange = (e) =>{
    setValues((previousdata)=> {
       return {
		...previousdata,
		[e.target.name] : e.target.value 			
	   }
	});  	  
}	
	
 const onSubmit = (e) =>{
    e.preventDefault();
	// console.log("onsubmit");
    // console.log(initialvalues);
	authservices.login(initialvalues).then((response)=>{
		// console.log("response data");
		console.log(response);	
		if(response.status == 200){
			toast.current.show({ severity: 'success', summary: 'Login', detail: 'Successfully logged in!' }) 
			const token = response.data.token;
			const userdata = JSON.stringify(response.data.userdata);
			const companydata = JSON.stringify(response.data.company_data);
			const logo = JSON.stringify(response.data.logo);
			const permissions = JSON.stringify(response.data.permissons);
			localStorage.setItem('token',token); 
			localStorage.setItem('userdata',userdata); 
			localStorage.setItem('permissons',permissions);
			localStorage.setItem('companydata',companydata);
			localStorage.setItem('logo',logo);


			window.location.href = '/';
		  }else{
			toast.current.show({ severity: 'error', summary: 'Login', detail: response.data.data.message }) 
		 }     
	}).catch((error)=>{
		console.log(error);
	});
 }	


  return(
    <>
	<Toast ref={toast} />
	<div className="login-page">
		<div className="login-left">
			<img
                                    src="utan logo.png"
                                    alt="navbar brand"
                                    className="navbar-brand"
                                    height="80"
                                />
			<h1>Welcome Back</h1>
			<p>Access your dashboard</p>
		</div>
		<div className="login-right">
			<form onSubmit={onSubmit}>
			<h2>Forgot Password</h2>
			<input id="email" name="email" type="text" className="form-control" placeholder="email" required="" onChange={(e)=>onChange(e)} />

			<button type="submit">Send</button>
			
			</form>
		</div>
	</div>
	{/* <div className="login bg-primary">
		<div className="wrapper wrapper-login">
			<form onSubmit={(e) => onSubmit(e)} class="login100-form validate-form">
				<div className="container container-login animated fadeIn" style={{display: 'block'}}>
					<h3 className="text-center">Forgot Password</h3>
					<div className="login-form">
					<div className="form-sub">
						<div className="form-floating form-floating-custom mb-3">
						<input id="email" name="email" type="text" className="form-control" placeholder="email" required="" onChange={(e)=>onChange(e)} />
						<label for="Email">Email</label>
						</div>
						
					</div>
					<div className="form-action mb-3">
						<button type='submit' class="btn btn-primary w-100 btn-login">
							Send
						</button>
					</div>
					<div className="mt-4 text-center">
      <a href="/login" className="text-sm text-blue-600 hover:underline">
        Back to Sign In
      </a>
    </div>
					</div>
				</div>
			</form>
		</div>
	</div> */}
    </>
  );
}

export default Forgotpassword;